"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProjects = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../../__generated__/graphql");
const get_projects_constants_1 = require("./get-projects.constants");
const client_constants_1 = require("../../../client.constants");
const get_projects_query_1 = require("../get-projects.query");
const useProjects = () => {
    const _a = (0, react_2.useQuery)(get_projects_query_1.GET_PROJECTS, {
        variables: {
            first: client_constants_1.PAGE_SIZE_EXTRA_LARGE,
            sort: [{ createdAt: graphql_1.OrderBy.Desc }],
            after: null,
        },
        fetchPolicy: 'cache-first',
    }), { data } = _a, rest = __rest(_a, ["data"]);
    const projects = (0, react_1.useMemo)(() => {
        var _a, _b;
        const loadedProjects = (_b = (_a = data === null || data === void 0 ? void 0 : data.projects) === null || _a === void 0 ? void 0 : _a.edges.map(({ node }) => node)) !== null && _b !== void 0 ? _b : [];
        // TODO: add a filter on the BE side
        return loadedProjects.filter(({ description, slug }) => description !== get_projects_constants_1.TEST_PROJECT_DESCRIPTION && slug !== get_projects_constants_1.SYSTEM_PROJECT_SLUG);
    }, [data]);
    return Object.assign(Object.assign({}, rest), { projects });
};
exports.useProjects = useProjects;
